import './ProductListing.css';
import { ProductBox } from './ProductBox/ProductBox';
import { ApiProduct, ApiSpecialsProduct } from '../../types';
import { ProductContainer } from '../../state/product';

type ProductListingProps = {
	products: ApiProduct[];
	highlightId?: number | null;
	className?: string;
};

export const ProductListing = ({ products, highlightId, className = '' }: ProductListingProps): JSX.Element => {
	const { getSpecialsProducts } = ProductContainer.useContainer();
	const isSpecialProduct = (product: ApiProduct | ApiSpecialsProduct): product is ApiSpecialsProduct => {
		return 'newPrice' in product;
	};

	const mixedSpecialProducts = getSpecialsProducts(products);

	return (
		<div className={'product-listing ' + className}>
			{mixedSpecialProducts.map((p) => {
				const isSpecialPriceProduct = isSpecialProduct(p);
				return (
					<ProductBox
						highlight={isSpecialPriceProduct ? p.product.id === highlightId : p.id === highlightId}
						product={isSpecialPriceProduct ? p.product : p}
						key={isSpecialPriceProduct ? p.productId : p.id}
						disabled={isSpecialPriceProduct ? p.product.deliveryClass === 6 : p.deliveryClass === 6}
					/>
				);
			})}
		</div>
	);
};
